import { ViewMajorV2EventManagePage } from "./ViewMajorV2EventManagePage";

export default ViewMajorV2EventManagePage;
